/* Clairemont: bolletjes onder de productfoto's op mobiel, zoals in de oude theme. */
(function () {
  var MOBILE = window.matchMedia('(max-width: 749px)');

  function visibleItems(list) {
    return [].slice.call(list.querySelectorAll('.product__media-item')).filter(function (it) {
      return it.offsetParent !== null && !it.classList.contains('hidden');
    });
  }

  function build(gallery) {
    var old = gallery.querySelector('.cl-dots');
    if (old) old.remove();
    if (!MOBILE.matches) return;
    var list = gallery.querySelector('.product__media-list');
    if (!list) return;
    var items = visibleItems(list);
    if (items.length < 2) return;

    var wrap = document.createElement('div');
    wrap.className = 'cl-dots';
    items.forEach(function (it, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'cl-dot';
      b.setAttribute('aria-label', 'Image ' + (i + 1));
      b.addEventListener('click', function () {
        var left = it.getBoundingClientRect().left - list.getBoundingClientRect().left + list.scrollLeft;
        list.scrollTo({ left: left - (list.clientWidth - it.clientWidth) / 2, behavior: 'smooth' });
      });
      wrap.appendChild(b);
    });
    var slider = list.closest('slider-component') || list;
    slider.insertAdjacentElement('afterend', wrap);

    function update() {
      var lr = list.getBoundingClientRect();
      var center = lr.left + lr.width / 2, best = 0, dist = Infinity;
      items.forEach(function (it, i) {
        var r = it.getBoundingClientRect();
        var d = Math.abs(r.left + r.width / 2 - center);
        if (d < dist) { dist = d; best = i; }
      });
      [].forEach.call(wrap.children, function (b, i) { b.classList.toggle('is-active', i === best); });
    }
    if (!list.__clDots) {
      list.__clDots = true;
      list.addEventListener('scroll', function () {
        window.requestAnimationFrame(function () { var g = list.closest('media-gallery'); if (g && g.__clUpdate) g.__clUpdate(); });
      }, { passive: true });
    }
    gallery.__clUpdate = update;
    update();
  }

  function init() { document.querySelectorAll('media-gallery').forEach(build); }

  var timer;
  function later() { clearTimeout(timer); timer = setTimeout(init, 350); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('load', init);
  document.addEventListener('change', function (e) { if (e.target.closest && e.target.closest('variant-selects')) later(); });
  MOBILE.addEventListener && MOBILE.addEventListener('change', init);
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var changed = [].slice.call(muts[i].addedNodes).concat([].slice.call(muts[i].removedNodes));
      var onlyDots = changed.length && changed.every(function (c) { return c.nodeType !== 1 || (c.classList && c.classList.contains('cl-dots')) || (c.classList && c.classList.contains('cl-dot')); });
      if (onlyDots) continue;
      var n = muts[i].target;
      var hit = n.nodeType === 1 && n.matches('media-gallery, .product__media-list');
      if (!hit) hit = changed.some(function (c) { return c.nodeType === 1 && (c.matches('media-gallery') || (c.querySelector && c.querySelector('media-gallery'))); });
      if (hit) { later(); return; }
    }
  }).observe(document.body, { childList: true, subtree: true });
})();

/* Clairemont: footer zoals vroeger (inklapbaar op mobiel, nieuwsbrieftekst). */
(function () {
  function setup() {
    var footer = document.querySelector('footer.footer');
    if (!footer || footer.__cl) return;
    footer.__cl = true;
    footer.querySelectorAll('.footer-block, .footer-block--newsletter').forEach(function (b) {
      var h = b.querySelector('.footer-block__heading');
      if (!h) return;
      b.classList.add('cl-acc');
      h.setAttribute('role', 'button');
      h.setAttribute('tabindex', '0');
      function toggle() { b.classList.toggle('is-open'); }
      h.addEventListener('click', toggle);
      h.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); } });
    });
    var nl = footer.querySelector('.footer-block__newsletter');
    if (nl && !nl.querySelector('.cl-newsletter-text')) {
      var p = document.createElement('p');
      p.className = 'cl-newsletter-text';
      p.textContent = 'Subscribe to get special offers and once-in-a-lifetime deals.';
      var form = nl.querySelector('form');
      if (form) form.parentNode.insertBefore(p, form); else nl.appendChild(p);
    }
    footer.querySelectorAll('.newsletter-form__field-wrapper input[type=email]').forEach(function (i) { i.setAttribute('placeholder', 'Enter your email'); });
    footer.querySelectorAll('.newsletter-form__field-wrapper .field__label').forEach(function (l) { l.textContent = 'Enter your email'; });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup); else setup();
})();
